import { Auth } from "aws-amplify";

/**
 * Standard error logger for API .catch() blocks.
 * Usage: .catch(logAPIError) or .catch(error => { updateState(); logAPIError(error); })
 */
export function logAPIError(error) {
    console.log(error);
    if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
    } else if (error.request) {
        console.log(error.request);
    } else {
        console.log('Error', error.message);
    }
}

/**
 * Deletes all keys with null values from obj in place.
 */
export function cleanNullProperties(obj) {
    const keys = Object.keys(obj);
    for (let i = 0; i < keys.length; i++) {
        if (obj[keys[i]] == null) {
            delete obj[keys[i]];
        }
    }
}

/**
 * Copies text to the clipboard using a temporary textarea element.
 */
export function copyToClipboard(text) {
    var textField = document.createElement('textarea');
    textField.innerText = text;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
}

/**
 * Returns true when the location is an RMV Site or the Braintree Granite St location.
 * These locations use unslotedMembers instead of slots for most operations.
 */
export function isRMVOrGraniteLocation(location) {
    return location.includes("RMV Site") || location.includes("Braintree - Granite St");
}

/**
 * Maps a road test location to the prep lesson location students should be offered.
 * Granite St road tests use the West Roxbury prep lessons; Walpole road tests use
 * Walpole prep lessons.
 */
export function getPrepLessonLocation(roadTestLocation) {
    if (roadTestLocation === "Braintree - Granite St") {
        return "West Roxbury";
    }
    return roadTestLocation;
}

/**
 * Builds the AWS Amplify API options object, including the Cognito auth header.
 * @param {any} body - The request body to include.
 * @returns {Promise<Object>} Resolved options object ready for API.post().
 */
export async function buildAPIOptions(body) {
    const session = await Auth.currentSession();
    return {
        body,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': session.idToken.jwtToken
        }
    };
}
